import BaseViewController from "../base-view-controller";

class SigninSecurityPreferencesViewController extends BaseViewController {
  preprocessScreenData() {
    const { fields } = this.screen;

    if (fields.find(f => f.name === "security_question_section_title")) {
      const securityContainer = fields.find(
        f => f.name === "security_questions_container"
      ).fieldLayouts[0].containerFields;

      const securityTitle = fields.splice(
        fields.findIndex(f => f.name === "security_question_section_title"),
        1
      );

      securityContainer.unshift(securityTitle[0]);
    }
  }
}

export default SigninSecurityPreferencesViewController;
